module.exports = __webpack_public_path__ + "static/media/demoPage.83063c7f.md";